var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarningIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 92,
    viewBox: "0 0 100 92",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.9319 7.99797C47.2878 4.28004 52.7122 4.28004 55.0681 7.99796L87.4641 59.1218C89.9956 63.1166 87.1254 68.3333 82.396 68.3333H17.604C12.8746 68.3333 10.0044 63.1166 12.5359 59.1218L44.9319 7.99797Z",
    fill: "#FFA200"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M48.1918 42.8844L47.3779 31.3621C47.2188 29.0437 46.3836 25.2967 48.253 23.413C49.6757 21.964 53.0443 21.7148 54.0662 23.7231C54.9352 26.083 55.1273 28.6191 54.623 31.0723L53.5338 42.9336C53.487 44.05 53.229 45.1493 52.772 46.1793C52.5921 46.5126 52.3194 46.793 51.9834 46.99C51.6473 47.187 51.2608 47.2932 50.8656 47.2971C50.4705 47.301 50.0817 47.2024 49.7415 47.012C49.4012 46.8216 49.1224 46.5467 48.9353 46.217C48.5047 45.1499 48.2538 44.0253 48.1918 42.8844ZM51.0097 58.7159C50.0448 58.7107 49.1183 58.3576 48.4186 57.7284C47.719 57.0991 47.2987 56.241 47.2433 55.3286C47.188 54.4163 47.5017 53.5182 48.1207 52.8172C48.7396 52.1161 49.6173 51.6648 50.5752 51.555C51.0898 51.496 51.6117 51.5376 52.1087 51.677C52.6057 51.8165 53.0672 52.051 53.4649 52.3659C53.8625 52.6809 54.1877 53.0697 54.4206 53.5083C54.6534 53.947 54.7889 54.4262 54.8186 54.9163C54.8484 55.4065 54.7717 55.8972 54.5935 56.3582C54.4152 56.8192 54.1391 57.2408 53.7822 57.5968C53.4253 57.9528 52.9951 58.2358 52.5183 58.4283C52.0414 58.6208 51.528 58.7186 51.0097 58.7159Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningIcon);
export default __webpack_public_path__ + "static/media/warning-icon.6ebcc5bd90018c276ea9ddf1692109dd.svg";
export { ForwardRef as ReactComponent };